"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMMerchantApiClient = exports.endpoints = void 0;
const IListWarehouseResponse_1 = require("../models/warehouses/IListWarehouseResponse");
const IMUtils_1 = require("../utils/IMUtils");
const BaseApiClient_1 = require("./BaseApiClient");
exports.endpoints = {
    alerts: '/v1/merchant/alerts',
    dismiss: '/v1/merchant/alerts/dismiss',
    warehouse: '/v1/merchant/warehouse/list',
};
class IMMerchantApiClient extends BaseApiClient_1.BaseApiClient {
    async getAlerts(includeDismissedAlerts) {
        const filter = {
            include_dismissed: (0, IMUtils_1.formatIMBoolean)(includeDismissedAlerts),
        };
        const result = await this.request('GET', exports.endpoints.alerts, filter);
        return result.response ?? [];
    }
    async getWarehouses(include_disabled) {
        const filter = {
            include_disabled: (0, IMUtils_1.formatIMBoolean)(include_disabled),
        };
        const result = await this.request('GET', exports.endpoints.warehouse, filter);
        return result?.response || new IListWarehouseResponse_1.IListWarehouseResponse();
    }
    async dismissAlerts(alertIds) {
        const result = await this.request('POST', exports.endpoints.dismiss, undefined, alertIds);
        return result;
    }
}
exports.IMMerchantApiClient = IMMerchantApiClient;
